export const dependencyYaml = () => `dependencies:
  - id: "||VARIABLE_KEY_id||"
    name: "||VARIABLE_KEY_name||"
    description: ""
    dependencyKey: "||VARIABLE_KEY_dependencyKey||"
    objectId: "||VARIABLE_KEY_objectId||"
    dependedOn: "||VARIABLE_KEY_dependedOn||"
    type: KEYS
    data:
      filterSql: |-
        select 
          s.__id as __from_id,
          t.__id,
          t.__destination_id
        from "||VARIABLE_KEY_fromTable||" s
        left join "||VARIABLE_KEY_toTable||" t on t.primary_key = s.reference_key
      nullable: false
      constraints:
        - synced
      acceptedConditions: []
      keys:
        reference_key: primary_key`;
